declare global {
  interface Window {
    kurentoUtils: any;
  }
}

export const kurentoUtils = window.kurentoUtils;

export interface WebRtcPeerSendonly {
  processAnswer: (sdpAnswer: string, callback: (error: any) => void) => void;
  generateOffer: () => Promise<string>;
  dispose: () => void;
  on: (event: string, callback: Function) => void;
} 